<template>
  <div class="pt-0" style="padding-left: 2%; padding-right: 2%; background-color: #F8F9FA; padding-bottom: 2%; min-height: 100vh;">
    <OverlayLoading :loading="loading" />
    <v-row class="mb-2">
      <v-col cols="6">
        <img width="17" height="17" src="@/assets/icons/back-icon.png" class="mt-5 ml-0" style="cursor: pointer;" @click="goBack()">
        <span class="header-title ml-0">
          แก้ไข Tag
        </span>
        <!-- <v-chip
          v-show="chkSubmit === true"
          class="mb-2"
          color="#FEF5E9"
          text-color="#E9A016"
          >
            <span>รออนุมัติ</span>
        </v-chip> -->
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 d-flex align-center justify-end mt-4 action-top-btn">
        <!-- <v-btn v-if="checkBtnSubmit === true" width="18%" class="ma-2 mr-2" color="grey" depressed disabled>บันทึกข้อมูล</v-btn> -->
        <v-btn width="18%" class="ma-2 mr-5" color="#3776E9" dark @click="dialogConfirmSubmit = true">บันทึกข้อมูล</v-btn>
      </v-col>
    </v-row>
    <v-card height="auto" min-height="82vh" class="pt-7 pb-7" >
      <v-container fluid pa-0 >
        <v-row align="center" justify="center" >
          <v-col cols="11">
            <span class="blue--text text--darken-4 font-weight-bold mr-5 text-title-content">ชื่อ Tag</span>
          </v-col>
          <v-col cols="11">
            <v-divider class="mt-0 mb-0"/>
          </v-col>
        </v-row>
        <v-row class="ml-0" justify="center" align="center">
          <v-col cols="11" lg="11" md="11" class="" style="margin-top: -12px;">
            <span class="grey--text text-darken-4 mt-1 mb-1">ชื่อ Tag</span><br>
            <v-text-field
              v-model="tag"
              outlined
              placeholder="ระบุชื่อ Tag"
              dense
              >
              </v-text-field>
          </v-col>
        </v-row>
        <v-row align="center" justify="center" >
          <div class="update-chart-full pt-1 pb-4 rounded-0" style="min-width:50vw; width:72vw; max-width:90vw;">
            <div class="text-left">
              <span class="blue--text text--darken-4 font-weight-bold mr-5 text-title-content">สมาชิก</span>
            </div>
            <v-divider class="mt-1 mb-4"/>
          </div>
          <v-col cols="11" class="pt-0 pb-0 d-flex align-end justify-end mt-4" style="margin-top: -1%;">
            <v-btn
              outlined
              class="ra-button-companyEdit"
              dark
              @click="openDialogAddAprover('add', '', '', 'approver')"
            >
            <v-icon left dark color="#fff" size="14px">fa-plus</v-icon>
            <span class="ra-text-in-button-companyEdit">
              เพิ่มข้อมูล
            </span>
          </v-btn>
          </v-col>
          <v-col cols="11" class="mx-auto px-0 mb-5">
            <v-data-table
              :headers="headers"
              :items="employeeList"
              class="border-table-employee text-no-wrap mt-1"
              item-key="_id"
              :expanded.sync="expanded"
              show-expand
              :loading="loading"
              loader-height=0
              loading-text="Loading... Please wait"
              disable-sort
            >
              <template v-slot:[`item.no`]="{ item }">
                {{ employeeList.indexOf(item)+1 }}
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-row class="d-flex">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        rounded
                        dark
                        icon
                        class="ra-border-button mt-3 mb-3 ml-3"
                        @click="checkRemove(item, 'employee')"
                      >
                      <template v-slot>
                        <v-icon dark color="#D1392B" size="19px">mdi-delete-outline</v-icon>
                      </template>
                      </v-btn>
                    </template>
                    <span class="label-table-action">รายชื่อสมาขิก</span>
                  </v-tooltip>
                </v-row>
              </template>
              <template v-slot:item.data-table-expand="{ expand, isExpanded, item }">
                <v-row class="d-flex px-3">
                  <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          rounded
                          dark
                          icon
                          class="ra-border-button mt-3 mb-3 ml-3"
                          @click="checkRemove(item, 'employee')"
                        >
                        <template v-slot>
                          <v-icon dark color="#D1392B" size="19px">mdi-delete-outline</v-icon>
                        </template>
                        </v-btn>
                      </template>
                      <span class="label-table-action">รายชื่อสมาขิก</span>
                    </v-tooltip>
                    <v-btn
                      class="mt-3"
                      color="primary"
                      text
                      icon
                      v-show="item.children"
                      @click="expand(!isExpanded)"
                    >
                      <v-icon v-if="!isExpanded">mdi-chevron-down</v-icon>
                      <v-icon v-else>mdi-chevron-up</v-icon>
                    </v-btn>
                </v-row>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <v-dialog v-model="dialogDeleteApprover" max-width="500px">
      <v-card height="170px">
        <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการลบข้อมูลนี้ ใช่หรือไม่?</v-card-title>
        <v-card-text class="justify-center text-center">
        <span class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลพนักงานคนนี้</span>
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn class="ra-button1" color="#1654C6" outlined @click="dialogDeleteApprover = false">ยกเลิก</v-btn>
          <v-btn class="ra-button1" color="#1654C6" dark @click="removeApprover(itemConfirmDelete)">ลบข้อมูล</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirmSubmit" max-width="500px">
      <v-card height="180px">
        <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการบันทึกข้อมูลใช่ไหม</v-card-title>
        <v-card-text class="justify-center text-center">
        <span class="ra-head-text justify-center">คุณแน่ใจหรือไม่ว่าต้องการบันทึกข้อมูล</span>
        <!-- <span v-else-if="titleDialog === 'temporaryer'" class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลผู้รักษาการคนนี้</span> -->
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn class="ra-button1" color="#1654C6" outlined @click="dialogConfirmSubmit = false">ยกเลิก</v-btn>
          <v-btn class="ra-button1" color="#1654C6" dark @click="submitData()">บันทึกข้อมูล</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-row>
        <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          :color="snackbarColor"
          text
          top
          app
          class="content-alert"
        >
        <v-icon left dark small :color="snackbarColor">fa-check-circle</v-icon>
        <span :style="{ 'color': `${snackbarColor}` }">{{ text }}</span>
        </v-snackbar>
      </v-row>
    </div>
    <DialogAddAprover/>
  </div>
</template>

<script>
import {
  updateTag
  // hostImageUrlv3
} from '@/API/API'
import swal from 'sweetalert'
import DialogAddAprover from '../_dialog/dialogAddApprover'
import { EventBus } from '@/EventBus'
// import FullLoading from '../../_template/FullLoading.vue'
import OverlayLoading from '../../_template/OverlayLoading.vue'

export default {
  components: {
    DialogAddAprover,
    OverlayLoading
  },
  name: 'showServiceDetail',
  data () {
    return {
      loading: false,
      expanded: [],
      snackbar: false,
      timeout: 2000,
      snackbarColor: '',
      text: '',
      dialogShow: false,
      promtDialog: false,
      dialogConfirmSubmit: false,
      dialogDeleteApprover: false,
      server: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}`,
      approveRole: localStorage.approveRole,
      editMode: false,
      chkSubmit: false,
      itemDetailData: [
        {
          name: '',
          tag: []
        }
      ],
      itemDetailDataOld: [
        {
          name: '',
          tag: []
        }
      ],
      employeeList: [],
      tag: '',
      headers: [
        {
          text: 'ลำดับ',
          align: 'left fixed',
          value: 'no',
          width: '70px',
          groupable: false,
          sortable: false,
          class: 'column-fix'
        },
        { text: 'รหัสพนักงาน', value: 'employeeId' },
        { text: 'ชื่อ-นามสกุล', value: 'name' },
        { text: 'ตำแหน่ง', value: 'position' },
        { text: 'ระดับตำแหน่ง', value: 'positionLevel' },
        { text: 'จัดการ', value: 'data-table-expand', sortable: false, width: '120px', align: 'center fixed', class: 'column-fix' }
      ]
    }
  },
  beforeDestroy () {
    EventBus.$off('addEmployeeTag')
  },
  mounted () {
    EventBus.$on('addEmployeeTag', this.add)
  },
  async created () {
    // this.initDataService(this.$route.params.id)
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.propsitems = this.$route.params.id
    await this.getDetailTag(this.propsitems)
    // await this.getUserDefault()
  },
  computed: {
    checkBtnSubmit () {
      const current = JSON.stringify(this.itemDetailData)
      const old = JSON.stringify(this.itemDetailDataOld)
      if (current !== old) {
        return false
      } else {
        return true
      }
    }
  },
  watch: {
  },
  methods: {
    goBack () {
      this.$router.push('/managetransferrole')
    },
    async changeMode () {
      if (this.editMode === false) {
        this.editMode = true
        // await this.getCompanyDetail(this.reqBusinessId)
      }
    },
    onImgError (i) {
      this.approver[i].failed_image = true
    },
    openDialogAddAprover (action, item, index, type) {
      EventBus.$emit('openDialogAddAprover', true, item, action, index, type)
    },
    add (val) {
      var filterValue = []
      // OLD
      // filterValue = this.employeeList.filter((r, index) => {
      //   if (r._id === val[0]._id && r.employeeId === val[0].employeeId) {
      //     return r
      //   }
      // })
      // for (let index = 0; index < val.length; index++) {
      //   if (filterValue.length > 0) {
      //     swal('คำเตือน', 'คุณได้เพิ่ม ' + filterValue[0].name + ' แล้ว', 'warning')
      //   } else {
      //     this.employeeList.push(val[index])
      //   }
      // }
      // NEW
      for (let i = 0; i < val.length; i++) {
        filterValue = this.employeeList.filter((r, index) => {
          if (r._id === val[i]._id && r.employeeId === val[i].employeeId) {
            return r
          }
        })
        if (filterValue.length > 0) {
          swal('คำเตือน', 'คุณได้เพิ่ม ' + filterValue[0].name + ' แล้ว', 'warning')
          // swal('คำเตือน', 'มีข้อมูลพนักงานซ้ำ', 'warning')
        } else {
          this.employeeList.push(val[i])
        }
      }
    },
    checkRemove (item, type) {
      this.itemConfirmDelete = []
      // this.titleDialog = type
      this.itemConfirmDelete = item
      this.dialogDeleteApprover = true
    },
    removeApprover (item) {
      this.employeeList.splice(this.employeeList.indexOf(item), 1)
      this.itemConfirmDelete = []
      this.itemIndex = 0
      this.dialogDeleteApprover = false
    },
    async getDetailTag (id) {
      this.loading = true
      await this.axios({
        method: 'post',
        url: `${this.api}/api/vMonk/authenTransfer/getTagDetail`,
        headers: {
          authorization: this.tokenUser
        },
        data: {
          tagId: id,
          limit: 15,
          page: 1
        }
      }).then((response) => {
        this.employeeList = response.data.result.member
        this.tag = response.data.result.name
        this.itemDetailData = response.data.result
        this.itemDetailDataOld = response.data.result
        // this.employeeData = response.data.result
        this.loading = false
        // this.dialogEdit = value
      }).catch(e => {
        console.log(e)
      })
    },
    async submitData () {
      this.loading = true
      this.loadingUsers = true
      // var userIdList = this.employeeList.find(x => x._id)
      var userIdList = this.employeeList.map(obj => obj._id)
      const obj = {
        tagId: this.propsitems,
        memberId: userIdList,
        tagName: this.tag
      }
      if (this.tag === '' || this.employeeList.length === 0) {
        swal('คำเตือน', 'กรุณากรอกข้อมูลให้ครบ', 'warning')
      } else {
        try {
          const res = await updateTag(obj, this.$store.state.token)
          if (res.success) {
            // this.token = res.token
            swal('สำเร็จ', 'แก้ไขข้อมูล เรียบร้อยแล้ว', 'success', {
              button: false,
              timer: 2000
            })
            setTimeout(() => {
              this.dialogConfirmSubmit = false
              this.chkSubmit = true
              this.goBack()
            }, 1500)
          }
        } catch (error) {
          console.log(error)
          swal('ผิดหลาด', 'แก้ไขข้อมูล ไม่สำเร็จ', 'success', {
            button: false,
            timer: 2000
          })
        } finally {
          this.loading = false
          this.loadingUsers = false
        }
      }
    }
  }
}
</script>
<style scoped>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0 !important;
}
.v-input {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}
.txt-font {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 5px;
  color: #757575;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
/* src\assets\logo.png */
/* '@/assets/icons/no_user.png' */
/* src\assets\icons\no_user.png */
.button {
  border: none;
  color: white;
  /* padding: 15px 32px; */
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
}
label {
  background-color: indigo;
  color: white;
  /* padding: 0.5rem; */
  padding: 0.7rem;
  font-family: sans-serif;
  border-radius: 0.3rem;
  cursor: pointer;
  margin-top: 1rem;
}
/* upfile pdf */

  /* อัปโหลดไฟล์ */
  .upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.btn_click {
  border: 2px solid gray;
  /* color: gray; */
  background-color: white;
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: bold;
}

.ra-head-text-bold {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Color / Primary / Hover */

  color: #1654C6;
}
.ra-head-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
}
.ra-span-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #757575;
}
.content-alert >>> .v-snack__wrapper {
  min-width: 15px !important;
}
.ra-button-companyEdit{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 9px 24px;

  position: absolute;
  width: 157px;
  height: 36px;

  /* Color / Primary / Default */

  background: #3776E9;
  border-radius: 4px;
}
.ra-text-in-button-companyEdit {
  font-family: 'Sarabun', sans-serif;
  /* font-weight: normal; */
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
}
</style>
